// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c6c54a16","977":"b3b3b84a"}[chunkId] + ".chunk.js";
};